import React from 'react';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './hooks/useAuth';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: 10,
            background: '#0f172a',
            color: '#fff',
            fontSize: 14,
            padding: '10px 14px'
          },
          success: { iconTheme: { primary: '#10b981', secondary: '#0f172a' } },
          error:   { iconTheme: { primary: '#ef4444', secondary: '#0f172a' } }
        }}
      />
    </AuthProvider>
  );
}

export default App;
